import { useState } from "react";
import { ServiceRendering } from "../../services/callAPI/trocsRequests";
import UnvalidToast from "../toasts/UnvalidToast";
import ValidToast from "../toasts/ValidToast";

interface IBtnServiceRenderProps {
  id: number,
  travTrocId: number,
  setTrigUseEffect: React.Dispatch<React.SetStateAction<boolean>>
}

function BtnServiceRender(props: IBtnServiceRenderProps) {
  //destructuring
  const { id, travTrocId, setTrigUseEffect } = props;

  const [isShowValidToast, setIsShowValidToast] = useState<boolean>(false);

  const [isShowUnvalidToast, setIsShowUnvalidToast] = useState<boolean>(false);

  async function handleServiceDone(id: number, travTrocId: number) {
    try {

      const response = await ServiceRendering(id, travTrocId);

      if (response.status === 204) {
        //show ValidToast
        setIsShowValidToast(true);

        setTimeout(() => {
          setTrigUseEffect(prev => !prev);
        }, 2000);
      }
      else {

        throw new Error(`Erreur lors de l'appel API code statut: ${response.status}`);

      }
    } catch (error) {
      //show UnvalidToast
      setIsShowUnvalidToast(true);

      // missing toast next 3s
      setTimeout(() => {
        setIsShowUnvalidToast(false);
      }, 3000)

    }
  }

  return (
    <>
      {isShowValidToast && <ValidToast onClose={() => setIsShowValidToast(false)} />}
      {isShowUnvalidToast && <UnvalidToast onClose={() => setIsShowUnvalidToast(false)} />}

      <button className="w-1/2 max-w-52 bg-greenCustom rounded-md py-1 px-4 text-white" onClick={() => {
        handleServiceDone(id, travTrocId)
      }}>
        Troc effectué ?
      </button>
    </>
  )
}
export default BtnServiceRender;